import { render, staticRenderFns } from "./AppCurrentScore.vue?vue&type=template&id=482f86c6&scoped=true&"
import script from "./AppCurrentScore.vue?vue&type=script&lang=js&"
export * from "./AppCurrentScore.vue?vue&type=script&lang=js&"
import style0 from "./AppCurrentScore.vue?vue&type=style&index=0&id=482f86c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482f86c6",
  null
  
)

export default component.exports